export const getConfirmFieldsFromPickingItem = (pickingItem) => {
    const { id, article, brand, name } = pickingItem;
    return {
        id,
        article,
        brand,
        name,
    };
};
